export const TENANT_ID = window.TENANT_ID;
export const CLIENT_ID = window.CLIENT_ID;
window.CKEDITOR.config.externalPlugins = false;
window.CKEDITOR.config.versionCheck = false;
